import { render, staticRenderFns } from "./Found.vue?vue&type=template&id=4188abca&scoped=true&"
import script from "./Found.vue?vue&type=script&lang=js&"
export * from "./Found.vue?vue&type=script&lang=js&"
import style0 from "./Found.vue?vue&type=style&index=0&id=4188abca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4188abca",
  null
  
)

export default component.exports